import { render, staticRenderFns } from "./AppParagraph.vue?vue&type=template&id=238af430&scoped=true&"
import script from "./AppParagraph.vue?vue&type=script&lang=js&"
export * from "./AppParagraph.vue?vue&type=script&lang=js&"
import style0 from "./AppParagraph.vue?vue&type=style&index=0&id=238af430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238af430",
  null
  
)

export default component.exports